import { render } from "./ProposalListItem.vue?vue&type=template&id=5c8a9920&scoped=true"
import script from "./ProposalListItem.vue?vue&type=script&lang=js"
export * from "./ProposalListItem.vue?vue&type=script&lang=js"

import "./ProposalListItem.vue?vue&type=style&index=0&id=5c8a9920&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8a9920"]])

export default __exports__